module.exports = {"421081001":"绣林街道","421081002":"笔架山街道","421081100":"新厂镇","421081101":"横沟市镇","421081102":"大垸镇","421081103":"小河口镇","421081104":"桃花山镇","421081105":"调关镇","421081106":"东升镇","421081107":"高基庙镇","421081108":"南口镇","421081109":"高陵镇","421081110":"团山寺镇","421081200":"久合垸乡","421081500":"天鹅洲开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421081.json
// module id = 1892
// module chunks = 0